import Dashboard from './pages/dashboard/Dashboard';
import Kehadiran from './pages/kehadiran/Kehadiran';
import Karyawan from './pages/karyawan/Karyawan';
import Kalender from './pages/kalender/Kalender';
import './styles/css/App.css';
import Login from './pages/Auth/Login';
import Detail from './pages/kehadiran/Detail';
import { Route, Routes } from 'react-router';
import AddKaryawan from './pages/karyawan/AddKaryawan';
import DetailKaryawan from './pages/karyawan/DetailKaryawan';
import NotFound from './components/NotFound';
import KalenderAddOrDetail from './pages/kalender/KalenderAddOrDetail';
import Pengaturan from './pages/pengaturan/Pengaturan';
import AlertNotAuthorize from './middleware/AlertNotAuthorize';
import NoInternetConnection from './middleware/NoInternetConnection';
import WrapperCalendar from './contexts/app/WrapperCalendar';
import ResponsiveAlert from './middleware/ResponsiveAlert';
import PrivateRoutes from './middleware/PrivateRoutes';
import JadwalGuru from "./pages/jadwalguru/JadwalGuru";
import Siswa from "./pages/siswa/Siswa";
import AddSiswa from "./pages/siswa/AddSiswa";
import DetailSiswa from "./pages/siswa/DetailSiswa";
import Jurnal from "./pages/jurnal/Jurnal";
import AddJadwalGuru from "./pages/jadwalguru/AddJadwalGuru";
import JurnalDetail from "./pages/jurnal/JurnalDetail";
import {ProfileApiProvider} from "./contexts/api/ApiProfile";
import AssignGuruSiswa from "./pages/assign-guru-siswa/AssignGuruSiswa";
import PenilaianGuru from "./pages/penilaian-guru/PenilaianGuru";
import AssignTambahGuruKelas from "./pages/assign-tambah-guru-kelas/AssignTambahGuruKelas";
import SiswaAttendanceHistory from "./pages/siswa-attendance-history/SiswaAttendanceHistory";
import JurnalSiswa from "./pages/jurnalsiswa/JurnalSiswa";

import BuatSoal from "./pages/buat-soal/BuatSoal";
import ModalCardDemo from "./pages/modal-card/ModalCard";


import DashboardKelas from "./pages/dashboard-kelas/DashboardKelas";
import DetailPenilaianGuru from "./pages/penilaian-guru/DetailPenilaianGuru";
import WaliKelas from "./pages/wali-kelas/WaliKelas";
import AddWaliKelas from "./pages/wali-kelas/AddWaliKelas";
import DetailWaliKelas from "./pages/wali-kelas/DetailWaliKelas";

function App() {
  return (
    <>
      <ResponsiveAlert>
        <NoInternetConnection>
        <ProfileApiProvider>
          <Routes>
            <Route element={<PrivateRoutes />}>
              <Route path='/' element={<Dashboard />} />

                <Route path='/monitorkelas' element={<DashboardKelas />} />
                <Route path='/buatsoal' element={<BuatSoal />} />
                <Route path='/penilaianguru' element={<PenilaianGuru />} />
                <Route path='/penilaianguru/detail/:id' element={<DetailPenilaianGuru />} />
                <Route path='/kehadiransiswa*' element={<SiswaAttendanceHistory />} />
                <Route path='/jurnalsiswa/*' element={<JurnalSiswa />} />

              <Route path='/kehadiran/*' element={<Kehadiran />} />
              <Route path='/kehadiran/detail/:izin?/:id' element={<Detail />} />

                <Route path='/jurnalguru/*' element={<Jurnal />} />
                <Route path='/jurnalguru/detail/:id' element={<JurnalDetail />} />




              <Route path='/karyawan/*' element={<Karyawan />} />
              <Route path='/karyawan/add' element={<AddKaryawan />} />
              <Route path='/karyawan/edit/:id' element={<DetailKaryawan />} />


                <Route path='/jadwalguru/*' element={<JadwalGuru />} />
                <Route path='/jadwalguru/add' element={<AddJadwalGuru />} />
                <Route path='/siswa/' element={<Siswa />} />
                <Route path='/siswa/add' element={<AddSiswa />} />
                <Route path='/siswa/edit/:id' element={<DetailSiswa />} />

                <Route path='/wali-kelas' element={<WaliKelas />} />
                <Route path='/wali-kelas/add' element={<AddWaliKelas />} />
                <Route path='/wali-kelas/edit/:id' element={<DetailWaliKelas />} />

              <Route
                path='/kalender'
                element={
                  <WrapperCalendar>
                    <Kalender />
                  </WrapperCalendar>
                }
              />
              <Route path='/kalender/add/:date?/:id?' element={<KalenderAddOrDetail />} />

              <Route path='/pengaturan/*' element={<Pengaturan />} />



              <Route path='*' element={<NotFound />} />
            </Route>











            <Route path='/login' element={<Login />} />
          </Routes>



          <AlertNotAuthorize />
      </ProfileApiProvider>
        </NoInternetConnection>
      </ResponsiveAlert>
    </>
  );
}

export default App;
